import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { blockMetrics, customizedBlock, isReportState } from 'venn-state';

import { useAppPrintMode } from '../../../print';
import { DATA_TYPE_EXCEL_STYLES, useResponseParser } from '../../../studio-blocks';
import { GridWrapper } from '../../../studio-blocks/common';
import ExportableGrid from '../../../studio-blocks/components/grid/ExportableGrid';
import { useCommonTreeGridProps } from '../../../studio-blocks/logic/columnUtils';
import { useIsBlockGridCompact } from '../../../studio-blocks/logic/useIsBlockGridCompact';
import { treeGridColDefOverrides } from '../../utils';
import { useAnalysisTreeGrid } from '../../utils/hooks/use-analysis-tree-grid';
import { useFilteredRequestsAndAnalyses } from '../../utils/hooks/use-filtered-requests';

interface PortfolioContributionContentProps {
  id: string;
}

export const PortfolioContributionContent = ({ id }: PortfolioContributionContentProps) => {
  const { inPrintModeOrReportLab } = useAppPrintMode();
  const isReport = useRecoilValue(isReportState);

  const { requests, analyses: analysesGroup } = useFilteredRequestsAndAnalyses(id);
  const selectedBlock = useRecoilValue(customizedBlock(id));

  const responseParser = useResponseParser(id);
  const setSelectedMetricsIds = useSetRecoilState(blockMetrics(id));

  const { rowData, columnDefs, autoGroupColumnDef, onDragStoped } = useAnalysisTreeGrid(
    requests,
    responseParser,
    analysesGroup,
    id,
    selectedBlock,
    setSelectedMetricsIds,
    inPrintModeOrReportLab,
  );

  const treeGridProps = useCommonTreeGridProps(treeGridColDefOverrides);
  const isCompact = useIsBlockGridCompact();

  return (
    <GridWrapper isReport={isReport}>
      <ExportableGrid
        {...treeGridProps}
        selectedRefId={id}
        rowData={rowData}
        exportable
        columnDefs={columnDefs}
        excelStyles={DATA_TYPE_EXCEL_STYLES}
        autoGroupColumnDef={autoGroupColumnDef}
        onDragStopped={onDragStoped}
        isCompact={isCompact}
        inPrintMode={inPrintModeOrReportLab}
      />
    </GridWrapper>
  );
};
